<template>
  <div class="overlay">
    <!-- alertdialog, not dialog: this interrupts the user with a time-limit warning.
         It has no dismiss control (the countdown logs the user out), so the mixin
         focuses the dialog itself and keeps Tab inside it. -->
    <div
      ref="dialog"
      class="modal"
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="idle-modal-title"
      aria-describedby="idle-modal-desc"
    >
      <div class="modal__title">
        <h4 id="idle-modal-title">Account Inactivity...</h4>
      </div>
      <div class="py-5">
        <p class="mb-5" id="idle-modal-desc">
          Due to account inactivity, you will be logged out in 5 minutes.
        </p>
      </div>
      <vs-progress :percent="percent" color="danger"></vs-progress>
    </div>
  </div>
</template>

<script>
import store from '@/store/store';
import dialogMixin from '@/mixins/dialog';
export default {
  mixins: [dialogMixin],
  data() {
    return {
      logout_after_ms: 300 * 1000, //300
      time: 300, //300,
      divider: 3, //3
    };
  },
  computed: {
    percent() {
      return this.time / this.divider;
    },
  },
  created() {
    var start_time = new Date();
    let timerId = setInterval(() => {
      this.time -= 1;
      if (!this.$store.state.idleVue.isIdle) clearInterval(timerId);
      let milliseconds_since_start = new Date().valueOf() - start_time;
      if (milliseconds_since_start >= this.logout_after_ms) {
        this.setIsIdle(false);
        clearInterval(timerId);
        // Your logout function should be over here
        const loginType = localStorage.getItem('login_type');
        if (loginType == 'student') {
          store.dispatch('authStudent/logout');
        } else if (loginType == 'teacher') {
          store.dispatch('authTeacher/logout');
        }
      }
    }, 1000);
  },
  inject: ['setIsIdle'],
  methods: {
    // Any activity already clears the idle state, so Escape should too. Without it the
    // focus trap would have no keyboard exit (WCAG SC 2.1.2 No Keyboard Trap).
    onDialogClose() {
      this.setIsIdle(false);
    },
  },
};
</script>

<style scoped>
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 99999;
}
.modal {
  background: #fff;
  position: absolute;
  top: 20%;
  width: 40%;
  left: 30%;
  padding: 30px;
}
</style>
